export enum MutationType {
    INCOMING = 'incoming',
    OUTGOING = 'outgoing',
    SYNC = 'sync'
}